import { render, staticRenderFns } from "./OtherChildren.vue?vue&type=template&id=0bc7790e&scoped=true&"
import script from "./OtherChildren.vue?vue&type=script&lang=js&"
export * from "./OtherChildren.vue?vue&type=script&lang=js&"
import style0 from "./OtherChildren.vue?vue&type=style&index=0&id=0bc7790e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7790e",
  null
  
)

export default component.exports